export default __webpack_public_path__ + "static/media/founder.d6fc0973.png";